// noinspection DuplicatedCode

import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";

import {alertService} from "../../../services/AlertService";

import TableCard from "../../../components/tablecard/TableCard";
import ModalForm from "../../../components/modal/form/ModalForm";

import {getJamKerja, insertJamKerja, jamKerjaSelector, updateJamKerja} from "./jamKerjaSlice";

import {Colors} from "../../../assets/Colors";

const JamKerjaPage = ({}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [firstLoading, setFirstLoading] = useState(false);
    const [start, setStart] = useState(0);
    const [count, setCount] = useState(5);
    const [page, setPage] = useState(1);
    const [maxPage, setMaxPage] = useState(0);
    const [search, setSearch] = useState("");
    const [searchFetch, setSearchFetch] = useState(false);
    const [insertFetch, setInsertFetch] = useState(false);
    const [updateFetch, setUpdateFetch] = useState(false);
    const [showModalAdd, setShowModalAdd] = useState(false);
    const [showModalEdit, setShowModalEdit] = useState(false);
    const [currentData, setCurrentData] = useState({});

    const jamKerja = useSelector(jamKerjaSelector);

    useEffect(() => {
        dispatch(
            getJamKerja({
                start: start,
                count: count,
                search: "",
            })
        );
    }, []);

    useEffect(() => {
        if (search !== "" && jamKerja?.isGetSuccess && !jamKerja.isGetFetching) {
            let calc = jamKerja?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if ((calc % count) === 0) {
                calc = calc + 1;
            }

            let tempMaxPage = jamKerja.data ? Math.ceil(calc / count) : 1;
            setSearchFetch(false);
            setMaxPage(tempMaxPage);
        }

        if (search === "" && jamKerja?.isGetSuccess && !jamKerja.isGetFetching) {
            let calc = jamKerja?.count - 1;

            if (calc === 0) {
                calc = 1;
            }

            if ((calc % count) === 0) {
                calc = calc + 1;
            }

            setSearchFetch(false);
            setMaxPage(Math.ceil(calc / count));
        }

        if (
            !jamKerja?.isGetFetching &&
            jamKerja?.isGetSuccess &&
            maxPage === 0 &&
            firstLoading === false
        ) {
            let calc = jamKerja?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if ((calc % count) === 0) {
                calc = calc + 1;
            }
            setMaxPage(Math.ceil(calc / count));
            setFirstLoading(true);
            dispatch(
                getJamKerja({
                    start: start,
                    count: count,
                    search: search,
                })
            );
        }

        if (insertFetch) {
            setInsertFetch(false);
            alertService.success(jamKerja.message, {
                autoClose: true,
                keepAfterRouteChange: false,
            });
            dispatch(
                getJamKerja({
                    start: start,
                    count: count,
                    search: search,
                })
            );
        }

        if (updateFetch) {
            setUpdateFetch(false);
            alertService.success(jamKerja.message, {
                autoClose: true,
                keepAfterRouteChange: false,
            });
            dispatch(
                getJamKerja({
                    start: start,
                    count: count,
                    search: search,
                })
            );
        }
    });

    // function handleGetJamKerja(params) {
    //   return dispatch(getJamKerja(params));
    // }

    function handleInsertJamKerja(param) {
        setInsertFetch(true);
        const params = {
            namaJamKerja: param.inputOneValue,
            waktuKerja: param.inputNumberOneValue,
        };
        dispatch(insertJamKerja(params));
    }

    function handleUpdateJamKerja(param) {
        setUpdateFetch(true);

        const params = {
            setupJamKerjaID: currentData.SetupJamKerjaID,
            namaJamKerja: param.inputOneValue,
            waktuKerja: param.inputNumberOneValue,
            status: param.status,
        };
        dispatch(updateJamKerja(params));
    }

    function handleSearch(searchValue) {
        let params = {
            start: 0,
            count: 5,
            search: searchValue,
        };
        dispatch(getJamKerja(params));

        setStart(0);
        setCount(5);
        setSearch(searchValue);
        setSearchFetch(true);
    }

    function handleUpdatePage(newPage) {
        let newStart = newPage * count - count;

        let params = {
            start: newStart,
            count: count,
            search: search,
        };
        dispatch(getJamKerja(params));

        setPage(newPage);
        setStart(newStart);
    }

    function handleUpdateCount(newCount) {
        let calc = jamKerja.count - 1;
        if (calc === 0) {
            calc = 1;
        }

        let params = {
            start: newCount === "-1" ? 0 : start,
            count: newCount === "-1" ? jamKerja.count : newCount,
            search: search,
        };
        dispatch(getJamKerja(params));

        setPage(1);
        setCount(newCount === "-1" ? jamKerja.count : newCount);
        setStart(newCount === "-1" ? 0 : start);
        setMaxPage(newCount === "-1" ? 1 : Math.ceil(calc / newCount));
    }

    function handleCurrentData(values) {
        setCurrentData(values);
    }

    function handleModal(status) {
        setShowModalAdd(status.showModalAdd);
        setShowModalEdit(status.showModalEdit);
    }

    if (!firstLoading) {
        return <div>loading</div>;
    } else {
        return (
            <div className="md:ml-64">
                <div style={{background: Colors.primary}} className="pt-14 pb-16 px-3 md:px-8 h-auto">
                    <div className="container mx-auto max-w-full">
                        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
                    </div>
                </div>

                <div className="px-3 md:px-8 h-auto -mt-32">
                    <div className="container mx-auto max-w-full">
                        <div className="grid grid-cols-1 px-4">
                            <TableCard
                                handleSearch={handleSearch}
                                searchPlaceholder="Jam Kerja"
                                updatePage={handleUpdatePage}
                                updateCount={handleUpdateCount}
                                currentData={handleCurrentData}
                                currentPage={page}
                                maxPage={maxPage}
                                tableTitle="Master Jam Kerja"
                                tableData={jamKerja.data}
                                colOneTitle="ID"
                                colOneData="SetupJamKerjaID"
                                colTwoTitle="Jenis Jam Kerja"
                                colTwoData="NamaSetupJamKerja"
                                colThreeTitle="Waktu Kerja"
                                colThreeData="WaktuKerja"
                                status="Status"
                                fetching={jamKerja.isGetFetching}
                                modal={handleModal}
                                editEnabled={true}
                            />
                        </div>
                    </div>
                </div>
                {showModalAdd && (
                    <ModalForm
                        showModal={showModalAdd}
                        addEnabled={true}
                        modal={handleModal}
                        modalTitle="Tambah Jam Kerja"
                        inputOneTitle="Nama Jam Kerja"
                        inputOnePlaceholder=""
                        inputNumberOneTitle="Waktu Kerja"
                        submitButtonTitle="Submit"
                        handleSubmit={handleInsertJamKerja}
                    />
                )}
                {showModalEdit && (
                    <ModalForm
                        showModal={showModalEdit}
                        editEnabled={true}
                        id={currentData.SetupJamKerjaID}
                        modal={handleModal}
                        modalTitle="Ubah Jam Kerja"
                        inputOneTitle="Nama Jam Kerja"
                        inputOneValue={currentData.NamaSetupJamKerja}
                        inputNumberOneTitle="Waktu Kerja"
                        status={currentData.Status}
                        submitButtonTitle="Submit"
                        handleSubmit={handleUpdateJamKerja}
                    />
                )}
            </div>
        );
    }
};

export default JamKerjaPage;
